import React, { useRef } from "react";
import { cls } from "@wss/cls";
import Hours from "../Header/Banner/Chat/Hours";
import ChatButton from "~/common/Buttons/ChatButton";
import connectUserAndChat, { Chat } from "~/common/Store/connectUserAndChat";
type Props = {
  chat: Chat;
  className?: string;
  toggleBorderOff?: boolean;
};
export default connectUserAndChat(function UseOurLiveChat({
  chat,
  className,
  toggleBorderOff
}: Props) {
  const repImageRef = useRef({
    image: `/uploads/design/2023/5/live-chat-${Math.ceil(Math.random() * 4)}.png`
  });
  return <div className={cls("bg-blue-50 lg:max-w-lg min-h-[321px] rounded-md", toggleBorderOff ? "" : "border-gray-200 border-solid border", className)}>
      <div className="flex flex-col items-center justify-center px-4 pt-5 text-center">
        <h2 className="font-bold text-2xl m-0 mt-2">Use Our Live Chat</h2>
        <p className="text-2xs leading-none mb-2.5">
          <Hours chat={chat} />
        </p>
        <ChatButton statusText={chat.statusText} />
        <img className="mt-5 max-w-3xs" alt="" src={repImageRef.current.image} />
      </div>
    </div>;
});